import { type FC } from 'react'

import { type AlgoliaRecord } from '../../../algolia'

type RecommendationProductQuantityProps = {
  product: AlgoliaRecord
}

export const StoryblokProductBatteryQuantity: FC<
  RecommendationProductQuantityProps
> = ({ product }) => {
  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
    <span className="line-clamp-2 min-h-[42px] text-dark-primary-max">
      {[`${product.unitQuantityString} ${product.unit}`, product.pharmaForm]
        .filter(Boolean)
        .join(' | ')}
    </span>
  )
}
